export const FormsToolBarName = 'formsToolBarComponent';
